document.addEventListener('DOMContentLoaded', () => {
    const variantCards = document.querySelectorAll('.product-form__input--card .variant-card-wrapper input[type="radio"]');

    variantCards.forEach((input) => {
      input.addEventListener('change', (event) => {
        // Remove "selected" class from all cards
        document.querySelectorAll('.product-form__input--card .variant-card').forEach((card) => {
          card.classList.remove('selected');
        });

        
        // Add "selected" class to the parent label of the clicked input
        //event.target.closest('.product-form__input--card .variant-card').classList.add('selected');
          event.target.parentNode.querySelector('.variant-card').classList.add('selected');
      });
    });
  });